module.exports = __webpack_public_path__ + "static/img/ipas.d9f81ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ipas.jpg
// module id = 299
// module chunks = 1